import alertsReducer, { AlertsState } from "./store/alerts/alertsReducer";
import { combineReducers } from "redux";
import authReducer, { AuthState } from "./store/auth/authReducer";
import configReducer, { ConfigState } from "./store/config/configReducer";
import basketReducer, { BasketState } from "./store/basket/basketReducer";
import showReducer, { ShowState } from "./store/show/showReducer";
import pseudoModalsReducer, { PseudoModalState } from "./store/pseudoModal/pseudoModalsReducer";


export default combineReducers({
  alerts: alertsReducer,
  auth: authReducer,
  config: configReducer,
  basket: basketReducer,
  shows: showReducer,
  pseudoModals: pseudoModalsReducer
});

export interface State {
  alerts: AlertsState;
  auth: AuthState;
  config: ConfigState;
  basket: BasketState;
  shows: ShowState;
  pseudoModals: PseudoModalState;
}
